import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router";
import { connect } from "react-redux";

// @material-ui/core components
import InputBase from "@material-ui/core/InputBase";
import withStyles from "@material-ui/core/styles/withStyles";
import { alpha, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import MenuList from "@material-ui/core/MenuList";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import SearchIcon from "@material-ui/icons/Search";

// @material-ui/icons
import MenuIcon from "@material-ui/icons/Menu";
import Search from "@material-ui/icons/Search";
import PersonIcon from "@material-ui/icons/Person";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Notifications from "@material-ui/icons/Notifications";

// core components
import Button from "components/CustomButtons/Button";
import Logo from "assets/img/logo.png";
import osm from "../../assets/basemap/osm.PNG";
import dark from "../../assets/basemap/dark.PNG";
import {
  pushBasemapasli,
  pushFilter,
  pushSearchVessel,
  pushDialogSearch
} from "../../actions/portal";
import { fetchAlertAll, fetchAlertToday } from "../../api/alert";
import { pushloggingx } from "../../api/login";
import SearchPage from "../../views/Search/Search";

import pagesRoutes from "routes/pages.jsx";

import pagesHeaderStyle from "assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";
import { MenuItem } from "@material-ui/core";
import moment from "moment";

const top100Films = [
  { title: "The Shawshank Redemption", year: 1994 },
  { title: "The Godfather", year: 1972 },
  { title: "The Godfather: Part II", year: 1974 },
  { title: "The Dark Knight", year: 2008 },
  { title: "12 Angry Men", year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: "Pulp Fiction", year: 1994 }
];

const options = [
  {
    map: "OSM",
    src: osm
  },
  {
    map: "DARK",
    src: dark
  }
];

class Header1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDrawer: false,
      openSearch: false,
      anchorEl: null,
      cctv: null,
      openMap: null,
      logout: null,
      openAlert: false,
      name: localStorage.getItem("name"),
      oauth: localStorage.getItem("oauth"),
      alerts: [],
      searchnya: "",
      titleAlert: "",
      descriptionAlert: ""
    };
  }

  componentDidMount() {
    this.getAlert();
  }

  getAlert = () => {
    fetchAlertToday(moment().format("YYYY-MM-DD"))
      .then(response => {
        if (response != null) {
          this.setState({ alerts: response.data.results });

          // console.log(this.state.alerts, "alert");
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleClick = () => {
    this.getAlert();
    this.setState({ open: !this.state.open });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleDrawerToggle = () => {
    this.setState({ openDrawer: !this.state.openDrawer });
  };
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? true : false;
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.setState({ open: false });
    }
  }

  handleClickFilter = () => {
    this.props.pushFilter(false);
  };

  handleClickMenu = event => {
    event.preventDefault();
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClickCctv = event => {
    event.preventDefault();
    this.setState({ cctv: event.currentTarget });
  };

  handleClickMenuMap = event => {
    event.preventDefault();
    this.setState({ openMap: event.currentTarget });
  };

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  };

  handleCloseCctv = () => {
    this.setState({ cctv: null });
  };

  handleCloseMenuMap = () => {
    this.setState({ openMap: null });
  };

  handleMenuItemClick = (event, index) => {
    this.setState({ selectedIndex: index, anchorEl: null });
    this.props.pushBasemapasli(options[index].map);
  };

  handleClickLogout = event => {
    event.preventDefault();
    this.setState({ logout: event.currentTarget });
  };

  handleCloseLogout = () => {
    this.setState({ logout: null });
  };

  handleClickAlert = () => {
    this.setState({ openAlert: !this.state.openAlert });
  };

  handleCloseAlert = () => {
    this.setState({ openAlert: false });
  };
  handleCloseSearch = () => {
    this.setState({ openSearch: false });
  };

  logout = event => {
    event.preventDefault();
    localStorage.clear();
    // localStorage.history.clear();

    let urllogoutidaman = `https://login.idaman.pertamina.com/oidc/logout?id_token_hint=${
      this.state.oauth
    }`;

    if (this.state.oauth == "") {
      pushloggingx("Logout", "Logout")
        .then(response => {
          if (response != null) {
            // this.setState({ alerts: response.data.results });
            // console.log(this.state.alerts, "alert");
          }
        })
        .catch(error => {
          //this.props.pushToken(error);
          this.props.history.push("/pages/login#logout");
        });
      this.props.history.push("/pages/login#logout");
    } else {
      // window.open("https://identity.idaman.pertamina.com/logout");
      pushloggingx("Logout", "Logout")
        .then(response => {
          if (response != null) {
            // this.setState({ alerts: response.data.results });
            // console.log(this.state.alerts, "alert");
          }
        })
        .catch(error => {
          //this.props.pushToken(error);
          this.props.history.push("/pages/login#logout");
        });
      this.props.history.push("/pages/login#logout");
    }
  };

  keyPress = e => {
    if (e.keyCode == 13) {
      this.setState({ openSearch: true, searchnya: e.target.value });
      this.props.pushSearchVessel(e.target.value);
      this.props.pushDialogSearch(true);
      // put the login here
    }
  };

  render() {
    const { classes, color, rtlActive } = this.props;
    const { open } = this.state;
    const appBarClasses = cx({
      [" " + classes[color]]: color
    });
    const dropdownItem = cx(classes.dropdownItem, classes.primaryHover, {
      [classes.dropdownItemRTL]: rtlActive
    });
    var list = (
      <div style={{ paddingRight: "50px" }}>
        <Grid container justify="center">
          <Grid item xs={12}>
            <List className={classes.list}>
              <ListItem className={classes.listItem}>
                <NavLink
                  to={"#"}
                  className={classes.navLink}
                  onClick={this.handleClickFilter}
                >
                  <ListItemText
                    primary="FILTER"
                    disableTypography={true}
                    className={classes.listItemText}
                  />
                </NavLink>
              </ListItem>
              <ListItem className={classes.listItem}>
                <NavLink
                  to={"#"}
                  className={classes.navLink}
                  onClick={this.handleClickMenuMap}
                >
                  <ListItemText
                    primary="BASEMAP"
                    disableTypography={true}
                    className={classes.listItemText}
                  />
                </NavLink>
                <Menu
                  id="lock-menu"
                  anchorEl={this.state.openMap}
                  style={{ top: "40px" }}
                  keepMounted
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center"
                  }}
                  open={Boolean(this.state.openMap)}
                  onClose={this.handleCloseMenuMap}
                >
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      selected={index === this.state.selectedIndex}
                      onClick={event => this.handleMenuItemClick(event, index)}
                    >
                      <div style={{ flexDirection: "row", fontSize: "10px" }}>
                        <Typography variant="body2">{option.map}</Typography>
                        <img
                          style={{
                            height: "60px",
                            width: "140px",
                            display: "block"
                          }}
                          alt="..."
                          src={option.src}
                        />
                      </div>
                    </MenuItem>
                  ))}
                </Menu>
              </ListItem>
              {this.props.routes.map((prop, key) => {
                if (prop.redirect) {
                  return null;
                }

                if (prop.collapse) {
                  const navLink =
                    classes.navLink +
                    cx({
                      [" " + classes.navLinkActive]: this.activeRoute(prop.path)
                    });
                  return (
                    <ListItem key={key} className={classes.listItem}>
                      <NavLink
                        to={"#"}
                        className={navLink}
                        onClick={this.handleClickMenu}
                      >
                        <ListItemText
                          primary={prop.short}
                          disableTypography={true}
                          className={classes.listItemText}
                        />
                        <ListItemIcon
                          style={{ minWidth: 0 }}
                          className={classes.listItemIcon}
                        >
                          <ExpandMoreIcon />
                        </ListItemIcon>
                      </NavLink>
                      <Menu
                        id="lock-menu"
                        anchorEl={this.state.anchorEl}
                        style={{ top: "40px" }}
                        // keepMounted
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center"
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center"
                        }}
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.handleCloseMenu}
                      >
                        <div style={{ display: "grid" }}>
                          {prop.views.map((prop, key) => {
                            if (prop.redirect) {
                              return null;
                            }
                            const navLink =
                              classes.navLink +
                              cx({
                                [" " + classes.navLinkActive]: this.activeRoute(
                                  prop.path
                                )
                              });
                            return (
                              <ListItem key={key} className={classes.listItem}>
                                <NavLink to={prop.path} className={navLink}>
                                  <ListItemText
                                    primary={prop.name}
                                    disableTypography={true}
                                    className={classes.listItemText}
                                  />
                                </NavLink>
                              </ListItem>
                            );
                          })}
                        </div>
                      </Menu>
                    </ListItem>
                  );
                }

                if (prop.cctv) {
                  const navLink =
                    classes.navLink +
                    cx({
                      [" " + classes.navLinkActive]: this.activeRoute(prop.path)
                    });
                  return (
                    <ListItem key={key} className={classes.listItem}>
                      <NavLink
                        to={"#"}
                        className={navLink}
                        onClick={this.handleClickCctv}
                      >
                        <ListItemText
                          primary={prop.short}
                          disableTypography={true}
                          className={classes.listItemText}
                        />
                        <ListItemIcon
                          style={{ minWidth: 0 }}
                          className={classes.listItemIcon}
                        >
                          <ExpandMoreIcon />
                        </ListItemIcon>
                      </NavLink>
                      <Menu
                        id="lock-menu"
                        anchorEl={this.state.cctv}
                        style={{ top: "40px" }}
                        // keepMounted
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center"
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center"
                        }}
                        open={Boolean(this.state.cctv)}
                        onClose={this.handleCloseCctv}
                      >
                        <div style={{ display: "grid" }}>
                          {prop.views.map((prop, key) => {
                            if (prop.redirect) {
                              return null;
                            }
                            const navLink =
                              classes.navLink +
                              cx({
                                [" " + classes.navLinkActive]: this.activeRoute(
                                  prop.path
                                )
                              });
                            return (
                              <ListItem key={key} className={classes.listItem}>
                                <NavLink to={prop.path} className={navLink}>
                                  <ListItemText
                                    primary={prop.name}
                                    disableTypography={true}
                                    className={classes.listItemText}
                                  />
                                </NavLink>
                              </ListItem>
                            );
                          })}
                        </div>
                      </Menu>
                    </ListItem>
                  );
                }

                if (prop.search) {
                  const navLink =
                    classes.navLink +
                    cx({
                      [" " + classes.navLinkActive]: this.activeRoute(prop.path)
                    });
                  return (
                    <ListItem key={key} className={classes.listItem}>
                      <NavLink
                        to={prop.path}
                        className={navLink}
                        style={{ paddingTop: "4px", paddingBottom: 0 }}
                      >
                        <Button type="submit" color="behance" round size="sm">
                          <Search />
                          {prop.name}
                        </Button>
                      </NavLink>
                    </ListItem>
                  );
                }

                const navLink =
                  classes.navLink +
                  cx({
                    [" " + classes.navLinkActive]: this.activeRoute(prop.path)
                  });
                return (
                  <ListItem key={key} className={classes.listItem}>
                    <NavLink to={prop.path} className={navLink}>
                      <ListItemText
                        primary={prop.short}
                        disableTypography={true}
                        className={classes.listItemText}
                      />
                    </NavLink>
                  </ListItem>
                );
              })}
              {/*ini dia */}

              <ListItem className={classes.listItem} style={{ paddingTop: 7 }}>
                <div className={classes.search}>
                  <div className={classes.searchIcon}>
                    <SearchIcon />
                  </div>
                  <InputBase
                    placeholder="Search…"
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput
                    }}
                    onKeyDown={this.keyPress}
                    inputProps={{ "aria-label": "search" }}
                  />
                </div>
              </ListItem>
              <ListItem className={classes.listItem}>
                <NavLink
                  to={"#"}
                  className={classes.navLink}
                  onClick={this.handleClickLogout}
                  style={{ paddingTop: "4px", paddingBottom: 0 }}
                >
                  <Button type="submit" color="behance" round size="sm">
                    <PersonIcon />
                    Hi, {this.state.name}
                    <ExpandMoreIcon />
                  </Button>
                </NavLink>
                <Menu
                  id="lock-menu"
                  anchorEl={this.state.logout}
                  style={{ top: "40px" }}
                  // keepMounted
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center"
                  }}
                  open={Boolean(this.state.logout)}
                  onClose={this.handleCloseLogout}
                >
                  <div style={{ display: "grid" }}>
                    <ListItem className={classes.listItem}>
                      <NavLink
                        to={"#"}
                        className={classes.navLink}
                        onClick={this.logout}
                      >
                        <ListItemText
                          primary="LOGOUT"
                          disableTypography={true}
                          className={classes.listItemText}
                        />
                      </NavLink>
                    </ListItem>
                  </div>
                </Menu>
              </ListItem>

              <ListItem className={classes.listItem}>
                <Button
                  color="transparent"
                  justIcon
                  aria-label="Notifications"
                  aria-owns={open ? "menu-list" : null}
                  aria-haspopup="true"
                  onClick={this.handleClick}
                  className={
                    rtlActive ? classes.buttonLinkRTL : classes.buttonLink
                  }
                  muiClasses={{
                    label: rtlActive ? classes.labelRTL : ""
                  }}
                  buttonRef={node => {
                    this.anchorEl = node;
                  }}
                >
                  <Notifications
                    style={{ fill: "#004d99" }}
                    className={
                      classes.headerLinksSvg +
                      " " +
                      (rtlActive
                        ? classes.links + " " + classes.linksRTL
                        : classes.links)
                    }
                  />
                  <span className={classes.notifications}>
                    {this.state.alerts.length}
                  </span>
                  <Hidden mdUp implementation="css">
                    <span
                      onClick={this.handleClick}
                      className={classes.linkText}
                    >
                      {rtlActive ? "إعلام" : "Notification"}
                    </span>
                  </Hidden>
                </Button>
              </ListItem>
              <Menu
                id="menu-list"
                anchorEl={this.anchorEl}
                style={{ top: "40px" }}
                // keepMounted
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center"
                }}
                open={open}
                onClose={this.handleClose}
              >
                <div style={{ display: "grid" }}>
                  <MenuList role="menu">
                    {this.state.alerts.map((v, i) => (
                      <MenuItem
                        key={i}
                        onClick={() => {
                          this.setState({
                            openAlert: !this.state.openAlert,
                            descriptionAlert: v.description,
                            titleAlert: v.title
                          });
                        }}
                        className={dropdownItem}
                      >
                        {v.title}
                      </MenuItem>
                    ))}
                  </MenuList>
                </div>
              </Menu>
            </List>
          </Grid>
        </Grid>
      </div>
    );
    return (
      <AppBar position="static" className={classes.appBar + appBarClasses}>
        <Toolbar className={classes.container}>
          <Hidden smDown>
            <div className={classes.flex}>
              <Button href="#" className={classes.title} color="transparent">
                <img src={Logo} alt="logo" className={classes.img} />
                EDTP 3.0
              </Button>
            </div>
          </Hidden>
          <Hidden mdUp>
            <div className={classes.flex}>
              <Button href="#" className={classes.title} color="transparent">
                EDTP 3.0
              </Button>
            </div>
          </Hidden>
          <Hidden smDown>{list}</Hidden>
          {/* <Hidden smDown>
            <HeaderLinks rtlActive={rtlActive} />
          </Hidden> */}
          <Hidden mdUp>
            <Button
              className={classes.sidebarButton}
              color="transparent"
              justIcon
              aria-label="open drawer"
              onClick={this.handleDrawerToggle}
            >
              <MenuIcon color="primary" />
            </Button>
          </Hidden>
          <Hidden mdUp>
            <Hidden mdUp>
              <Drawer
                variant="temporary"
                anchor={"right"}
                open={this.state.openDrawer}
                classes={{
                  paper: classes.drawerPaper
                }}
                onClose={this.handleDrawerToggle}
                ModalProps={{
                  keepMounted: true // Better open performance on mobile.
                }}
              >
                {list}
              </Drawer>
            </Hidden>
          </Hidden>
        </Toolbar>
        <Dialog
          maxWidth={"md"}
          open={this.state.openAlert}
          onClose={this.handleCloseAlert}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {this.state.titleAlert}
          </DialogTitle>
          <DialogContent>
            <Grid item xs={12} sm={12} md={12}>
              {this.state.descriptionAlert}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseAlert} color="danger" round>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          maxWidth={"md"}
          open={this.state.openSearch}
          onClose={this.handleCloseSearch}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Search</DialogTitle>
          <DialogContent>
            <Grid item xs={12} sm={12} md={12}>
              <SearchPage searchnya={this.state.searchnya} />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseSearch} color="danger" round>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </AppBar>
    );
  }
}

Header1.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  pushBasemapasli: PropTypes.string,
  pushFilter: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    basemapAsli: state.basemapAsli,
    filter: state.filter
  };
}

export default withStyles(pagesHeaderStyle)(
  withRouter(
    connect(
      mapStateToProps,
      { pushBasemapasli, pushFilter, pushSearchVessel, pushDialogSearch }
    )(Header1)
  )
);
